import ApiError from '../types/error';

export enum OperationStatus {
  NOT_STARTED = 1,
  RUNNING,
  ERRORED,
  COMPLETED
}

export interface OperationResult {
  error: ApiError | null;
  status: OperationStatus;
  progress?: number;
}
